import { SelectTravelExpenseReimbursement } from '../../select/SelectTravelExpenseReimbursement';

export const NewTravelExpenseReimbursementRelation = ({ onSubmit }) => {
  function handleSubmit(travelExpenseReimbursement) {
    onSubmit({ travelExpenseReimbursement, type: 'travelExpenseReimbursement' });
  }

  return <SelectTravelExpenseReimbursement onSelect={handleSubmit} />;
};
